export function getPipelineWidgetSecondaryExpandLabel(numTasks?: number | null) {
    if (!NutClientConfig.hasLeadPageRedesignM3FF && numTasks && numTasks > 0) {
        return `See +${numTasks} stage task${numTasks > 1 ? 's' : ''} and more`;
    }

    return 'See more';
}
